// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"772cb2a9","926":"484c6c2e"}[chunkId] + ".chunk.js";
};